<template>
	<div class="c-quick-links">
		<div class="o-width-limiter o-width-limiter--main">
			<div class="c-quick-links__container">
				<div class="c-quick-links__wrapper">
				<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VQuickLinksBlock"
};
</script>
